import React from "react";

export const Footer = () => {

  return (
    <div id="footer">
     
      <div className="container text-center">
        <p>
          {/* &copy; 2023 Premium Concealed Zippers by Ziphosa. Design by{" "} */}
          {/* <a href="http://www.templatewire.com" rel="nofollow"> */}All rights reserved
          by D.A ENTERPRISES
          {/* </a> */}
        </p>
      </div>
    </div>
  );
};
